import { Edit, Trash } from "react-feather";

export const societiesColumns = (onEdit, onDelete) => [
    {
      name: 'Id Posicion',
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: 'Nombre',
      selector: (row) => row.name,
      sortable: true,
    },
    // {
    //   name: 'Empresa',
    //   selector: (row) => row.company.name,
    //   sortable: true,
    // },
    {
      name: 'Acciones',
      center: true,
      allowOverflow: true,
      cell: (row) => (
        <div className='d-flex'>
          <div className='cursor-pointer text-primary'>
            <Edit onClick={() => onEdit(row)} size={20} />
          </div>
          <div className='ps-1 cursor-pointer'>
              <Trash size={20} onClick={() => onDelete(row.id)} />
          </div>
        </div>
      ),
    },
  ];